import React, { useEffect, useState } from "react";
import StorefrontTitle from "../shared/storefront-title.component";
import topUpSuccessImg from "../../assets/img/payment-success.svg";
import phoneImg from "../../assets/img/phone_calling.svg";
import Settings from "../../services/settings.service";
import DownloadApps from "../shared/DownloadApps";
import Storage from "../../services/storage.service";
import Translation from "../../services/translation.service";
import SpinnerTimeLoader from "../shared/timeLoading";
import checkModule from "../shared/checkModule";

const TopUpSuccess = (props) => {
  const [numbers, setNumbers] = useState([]);
  const [loader, setLoader] = useState(false);


  const prefix = "scr_3.3.3";
  const appDownloadInfo = Translation.keys[prefix + "_app_download_info"];

  useEffect(() => {
    Storage.set("topPaymentDone", true, true);
    Storage.set("topPaymentDone", true);
    if (Storage.get("TopNumberData", true)) {
      let topup_numbers = Storage.get("TopNumberData", true);


      setNumbers(JSON.parse(topup_numbers));
    }
  }, []);

  const topUpAgain = () => {
    setLoader(true);
    Storage.clear("session");
    localStorage.clear();
    Storage.set("is_web_category_selected", true, true);
    Storage.set("choose_topup_category", true, true);
    window.location.href = "/join/";
  }

  const redirectToHome = () => {
    setLoader(true);
    Storage.clear("session");
    localStorage.clear();
    window.location.href = "/join/"
  }
  return (
    <>
      {loader ? <SpinnerTimeLoader /> :
        <div className="stm-topup-info-container">
          <div className="success-img">
            <img src={topUpSuccessImg} alt="" />
          </div>
          <StorefrontTitle
            title={Translation.keys[prefix + "_title_success"]}
            desc={Translation.keys[prefix + "_subtitle_success"]}
          />
          <div className="topup-field-wrapper">
            {numbers.length > 0 && numbers ? (
              <div className="topup-numbers-container">
                {numbers.map((number, index) => {
                  return (
                    number?.Number &&
                    <div className="topup-number-row" key={index}>
                      <div className="topup-number">
                        <div className="num-container">
                          <img src={phoneImg} alt="" />
                          <span className="number">{number?.Number}</span>
                        </div>
                        <span className="cost">
                          {number?.Amount} {Translation.keys[prefix + "_price_unit"]}
                        </span>
                      </div>
                    </div>
                  );
                })}
              </div>
            ) : null}
            <div className="topup-btn-section">
              <button
                className="storefront-button light-red"
                type="button"
                onClick={() => { topUpAgain() }}
              >
                {Translation.keys[prefix + "_topup_again"]}
              </button>
              <button
                className="storefront-button-blue"
                type="button"
                onClick={() => { redirectToHome() }}
              >
                {Translation.keys[prefix + "_done"]}
              </button>
            </div>
          </div>
          {checkModule.isTopUpKsa ?
            <DownloadApps
              info={appDownloadInfo}
              classes={"download-apps"}
              google_play_link={Settings.google_play_link}
              app_store_link={Settings.app_store_link}
              huawei_store_link={Settings.huawei_store_link}
            />:null}
          {checkModule.isTopUpKw ?
            <DownloadApps
              info={appDownloadInfo}
              classes={"download-apps"}
              google_play_link={Settings.ob_google_play}
              app_store_link={Settings.ob_app_store}
              huawei_store_link={Settings.ob_app_gallery}
            /> : null}
        </div>
      }
    </>
  );
};

export default TopUpSuccess;
